module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"account":{"security":{"access_data":"Dados de acesso","devices":"Dispositivos","access_email":"Email de acesso","password":"Senha","password_confirmation":"Confirme a senha"}}},"en":{"account":{"security":{"access_data":"Access data","devices":"Devices","access_email":"Access email","password":"Password","password_confirmation":"Confirm password"}}}}')
  delete Component.options._Ctor
}
